/* Petbloom: accessible, section-editor-safe storefront interactions. */
(function () {
  'use strict';
  function initTabs(section) {
    if (section.dataset.pbTabsReady) return;
    var tabs = Array.from(section.querySelectorAll('[data-pb-tab]'));
    var panels = Array.from(section.querySelectorAll('[data-pb-panel]'));
    if (!tabs.length) return;
    section.dataset.pbTabsReady = 'true';
    function select(tab) {
      tabs.forEach(function (item) { var active = item === tab; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
      panels.forEach(function (panel) { var active = panel.dataset.pbPanel === tab.dataset.pbTab; panel.hidden = !active; panel.classList.toggle('is-active', active); });
    }
    tabs.forEach(function (tab, index) {
      tab.tabIndex = index === 0 ? 0 : -1;
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); tabs[next].focus(); select(tabs[next]);
      });
    });
  }
  function initGallery(section) {
    if (section.dataset.pbGalleryReady) return;
    var main = section.querySelector('[data-pb-gallery-main]');
    var stage = section.querySelector('[data-pb-gallery-stage]');
    var thumbs = Array.from(section.querySelectorAll('[data-pb-gallery-thumb]'));
    if (!main || !stage || !thumbs.length) return;
    section.dataset.pbGalleryReady = 'true';
    var active = 0;
    var requested = 0;
    var requestToken = 0;
    var preloaded = Object.create(null);
    var baseAlt = main.alt;
    var counter = section.querySelector('[data-pb-gallery-count]');
    var previous = section.querySelector('[data-pb-gallery-previous]');
    var next = section.querySelector('[data-pb-gallery-next]');
    var thumbRail = section.querySelector('.pb-product__thumbs');
    var touchStartX = 0;
    var touchStartY = 0;
    function normalise(index) { return (index + thumbs.length) % thumbs.length; }
    function sourceFor(thumb) {
      return window.matchMedia('(max-width: 680px)').matches && thumb.dataset.srcMobile ? thumb.dataset.srcMobile : thumb.dataset.src;
    }
    function preload(index) {
      index = normalise(index);
      var src = sourceFor(thumbs[index]);
      if (preloaded[src]) return preloaded[src].ready;
      var image = new Image();
      image.decoding = 'async';
      image.src = src;
      var ready = new Promise(function (resolve) {
        function finish() {
          if (typeof image.decode === 'function') image.decode().catch(function () {}).then(function () { resolve(src); });
          else resolve(src);
        }
        if (image.complete) finish();
        else { image.addEventListener('load', finish, { once: true }); image.addEventListener('error', function () { resolve(src); }, { once: true }); }
      });
      preloaded[src] = { image: image, ready: ready };
      return ready;
    }
    function warmAround(index) {
      [index - 1, index + 1, index + 2].forEach(function (candidate) { preload(candidate); });
    }
    function centreThumb(thumb) {
      if (!thumbRail || thumbRail.scrollWidth <= thumbRail.clientWidth) return;
      var left = thumb.offsetLeft - (thumbRail.clientWidth - thumb.offsetWidth) / 2;
      thumbRail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
    function syncSelection(index, announce) {
      active = index;
      main.alt = baseAlt + ' – image ' + (active + 1) + ' of ' + thumbs.length;
      if (counter) counter.textContent = (active + 1) + ' / ' + thumbs.length;
      thumbs.forEach(function (thumb, i) {
        var selected = i === active;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-pressed', String(selected));
      });
      if (announce) centreThumb(thumbs[active]);
    }
    function show(index, announce) {
      requested = normalise(index);
      var target = requested;
      var token = ++requestToken;
      var src = sourceFor(thumbs[target]);
      main.classList.add('is-changing');
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = src;
      syncSelection(target, announce);
      var ready = typeof main.decode === 'function' ? main.decode().catch(function () {}) : Promise.resolve();
      ready.then(function () {
        if (token !== requestToken) return;
        window.requestAnimationFrame(function () { main.classList.remove('is-changing'); });
      });
      preload(target);
      warmAround(target);
    }
    function move(amount) { show(requested + amount, true); }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i, true); });
      thumb.addEventListener('pointerenter', function () { preload(i); }, { passive: true });
      thumb.addEventListener('focus', function () { preload(i); });
      thumb.addEventListener('touchstart', function () { preload(i); }, { passive: true });
      thumb.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault(); show(requested + (event.key === 'ArrowRight' ? 1 : -1), true); thumbs[requested].focus();
      });
    });
    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    stage.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
    });
    stage.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX; touchStartY = event.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (event) {
      if (!event.changedTouches.length) return;
      var dx = event.changedTouches[0].clientX - touchStartX;
      var dy = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) >= 42 && Math.abs(dx) > Math.abs(dy) * 1.2) move(dx < 0 ? 1 : -1);
    }, { passive: true });
    syncSelection(0, false);
    warmAround(0);
  }
  function initFaq(section) {
    if (section.dataset.pbFaqReady) return;
    section.dataset.pbFaqReady = 'true';
    section.querySelectorAll('.pb-faq-item,.pb-product-accordions details').forEach(function (item) {
      var summary = item.querySelector('summary'); if (!summary) return;
      function update() { summary.setAttribute('aria-expanded', String(item.open)); }
      update(); item.addEventListener('toggle', update);
    });
  }
  function initVariant(section) {
    var selectors = Array.from(section.querySelectorAll('[data-pb-variant]'));
    if (!selectors.length || section.dataset.pbVariantReady) return;
    section.dataset.pbVariantReady = 'true';
    function update(source) {
      var option = source.matches('select') ? source.selectedOptions[0] : source;
      var price = section.querySelector('[data-pb-price]');
      var compare = section.querySelector('[data-pb-compare]');
      if (price) price.textContent = option.dataset.price;
      if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
      section.querySelectorAll('[data-pb-bundle-card]').forEach(function (card) {
        var input = card.querySelector('[data-pb-variant]');
        card.classList.toggle('is-selected', Boolean(input && input.checked));
      });
    }
    selectors.forEach(function (selector) { selector.addEventListener('change', function () { update(selector); }); });
    var current = section.querySelector('[data-pb-variant]:checked') || selectors[0];
    update(current);
  }
  function updatePetbloomCartCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('.pb-header__bag').forEach(function (link) {
          var dot = link.querySelector('.pb-cart-dot');
          if (dot) dot.textContent = cart.item_count;
          link.setAttribute('aria-label', 'Basket, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items'));
        });
      });
  }
  function initDeliveryEstimate(section) {
    section.querySelectorAll('[data-pb-delivery-estimate]').forEach(function (row) {
      if (row.dataset.pbDeliveryReady) return;
      row.dataset.pbDeliveryReady = 'true';
      var output = row.querySelector('[data-pb-delivery-date]');
      if (!output) return;
      var days = parseInt(row.dataset.deliveryDays || '3', 10);
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
      var values = {}; parts.forEach(function (part) { if (part.type !== 'literal') values[part.type] = parseInt(part.value, 10); });
      var delivery = new Date(Date.UTC(values.year, values.month - 1, values.day + days));
      var day = delivery.getUTCDate();
      var suffix = 'th';
      if (day % 100 < 11 || day % 100 > 13) suffix = day % 10 === 1 ? 'st' : day % 10 === 2 ? 'nd' : day % 10 === 3 ? 'rd' : 'th';
      var month = new Intl.DateTimeFormat('en-GB', { month: 'long', timeZone: 'UTC' }).format(delivery);
      output.textContent = month + ' ' + day + suffix;
      output.setAttribute('datetime', delivery.toISOString().slice(0, 10));
    });
  }
  function initCartForm(section) {
    var form = section.querySelector('.pb-product-form');
    if (!form || form.dataset.pbCartReady) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.getSectionsToRender !== 'function') return;
    form.dataset.pbCartReady = 'true';
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var status = form.querySelector('[data-pb-cart-status]');
      if (!button || button.disabled) return;
      var original = button.innerHTML;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = '<span>Adding…</span><span aria-hidden="true">•••</span>';
      if (status) { status.hidden = true; status.textContent = ''; }
      try {
        var formData = new FormData(form);
        formData.append('sections', drawer.getSectionsToRender().map(function (item) { return item.id; }).join(','));
        formData.append('sections_url', window.location.pathname);
        var response = await fetch(form.action, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: formData });
        var data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added to your cart.');
        drawer.renderContents(data);
        drawer.classList.remove('is-empty');
        await updatePetbloomCartCount();
        button.innerHTML = '<span>Added to cart</span><span aria-hidden="true">✓</span>';
        document.dispatchEvent(new CustomEvent('petbloom:cart-added', { detail: data }));
        window.setTimeout(function () { if (button.isConnected) button.innerHTML = original; }, 1400);
      } catch (error) {
        if (status) { status.textContent = error.message || 'This item could not be added to your cart.'; status.hidden = false; }
        else window.location.href = form.action;
        button.innerHTML = original;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  }
  function init(root) {
    (root || document).querySelectorAll('[data-pb-section]').forEach(function (section) { initTabs(section); initGallery(section); initFaq(section); initVariant(section); initDeliveryEstimate(section); initCartForm(section); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
